import { useEffect, useState } from 'react';
import { classes } from '../../Helpers';
import MeasurementBox from '../Analytics/Quality/Measurement/MeasurementBox';
import CheckMark from '../isVegCheckMark/CheckMark';
import { Button } from '../ui/button';
import styles from './AppQcReference.module.scss';
import { useAuth } from '../Auth/Login/auth';

function AppQcReference(props) {
	const {
		vendorName,
		source,
		isVeg,
		assetId,
		className,
		brand,
		name,
		weight,
		result,
		message,
		handleDelete = () => {},
		handleUpdate = () => {},
		isEdit = false,
		setIsEdit,
		pageType = '',
	} = props;

	const [updateValue, setUpdateValue] = useState('');
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const levels = [3, 4];
	const { userRolesDict = {} } = userConfig || {};
	const isInternal = Object?.values?.(userRolesDict ?? {}).includes('INTERNAL') || Object?.values?.(userRolesDict ?? {}).includes('Internal') || Object?.values?.(userRolesDict ?? {}).includes('Config Admin');

	const handleEdit = () => {
		setIsEdit((prev) => !prev);
	};
	useEffect(() => {
		setUpdateValue(weight?.piecesCount);
	}, [weight?.piecesCount]);

	const handleValue = (value) => {
		setUpdateValue(value);
	};

	return (
		<div className={classes(styles.root, className)}>
			<div className={styles.imageContainer}>
				{vendorName && (
					<div className={styles.vendor_name}>
						Vendor Name:
						{vendorName}
					</div>
				)}
				<img
					className={styles.image}
					src={source}
					alt='Food Reference'
				/>
				{isVeg != null && (
					<div className={styles.footer}>
						<img className={styles.brand} src={brand} alt='' />
						<CheckMark isVeg={isVeg} />
						<div className={styles['name-container']}>
							<p className={styles.name}>{name}</p>
							{assetId && <p>{assetId}</p>}
						</div>
					</div>
				)}
			</div>
			<div className={styles.measurement}>
				<div className={classes(styles.qcDone, styles[result])}>
					<p>{message}</p>
				</div>
				{pageType === 'productionHistory' && levels.includes(level) && isInternal && (
					<div className='flex justify-center items-center gap-2 w-full'>
						{isEdit ? (
							<Button
								onClick={() => handleUpdate(updateValue)}
								className='w-full bg-green-800 text-white hover:bg-green-600'
							>
								Save
							</Button>
						) : (
							<>
								{weight?.piecesCount && (
									<Button
										onClick={handleEdit}
										className='w-1/2 bg-blue-800 text-white hover:bg-blue-600'
									>
										Edit
									</Button>
								)}
								<Button
									onClick={handleDelete}
									className='w-1/2 bg-red-700 text-white hover:bg-red-500'
								>
									Delete
								</Button>
							</>
						)}
					</div>
				)}
				<MeasurementBox
					weight
					measurements={weight}
					classname={styles.box}
					isEdit={isEdit}
					updateValue={updateValue}
					handleUpdateValue={handleValue}
				/>
			</div>
		</div>
	);
}

export default AppQcReference;
